import {
  AppConfigSalesChannel,
  MobileAppsApi,
  MobileAppsSubmission,
  MobileAppsSubmissionStatus,
  UpdateMobileAppsSubmissionStatus,
} from '@flipdish/api-client-typescript';
import axios from 'axios';

import { getApiEndPoint } from '../../../helpers/apibase';
import { CredentialsAuth } from '../../../helpers/utilities';
import { mapServerError } from '../../../services/utils/serverErrorMapper';
import { AppType } from './types';

const api = new MobileAppsApi(getApiEndPoint());
api.setDefaultAuthentication(new CredentialsAuth());

const baseURL = getApiEndPoint();
const newMobileAppsApi = axios.create({
  baseURL: `${baseURL}/api/v1.0`,
  withCredentials: true,
});

const getStatistics = async (appId: string, appTypes: AppType[]) => {
  try {
    const result = await api.getStatistics(appId, appTypes);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const getMobileAppStatus = async (appId: string, appType: MobileAppsSubmissionStatus.TypeEnum) => {
  try {
    const result = await api.getSubmissionStatus(appId, appType);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const getSubmissionDetailsQueryKey = 'getSubmissionDetails';
const getSubmissionDetails = async (appId: string) => {
  try {
    const result = await api.getSubmissionDetails(appId);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const getSalesChannelConfig = async (appId: string) => {
  try {
    const result = await api.getAppConfigSalesChannel(appId);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const updateMobileAppSubmissionStatus = async (
  appId: string,
  submissionId: number,
  newStatus: UpdateMobileAppsSubmissionStatus
) => {
  try {
    const result = await api.updateSubmissionStatus(appId, submissionId, newStatus);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const updateSalesChannelConfig = async (
  appId: string,
  updatedConfig: Partial<AppConfigSalesChannel>
) => {
  try {
    const result = await api.updateAppConfigSalesChannel(appId, updatedConfig);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

// investigate why exposed TS upload function is broken
const uploadLogo = async (appId: string, image: File) => {
  try {
    const formData = new FormData();
    formData.append('file', image);

    const result = await newMobileAppsApi.post(`mobileapps/${appId}/submission/image`, formData);
    return result.data;
  } catch (e) {
    throw mapServerError(e);
  }
};

const saveSubmissionDetails = async (appId: string, mobileApp: MobileAppsSubmission) => {
  try {
    const result = await api.submission(appId, mobileApp);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

const updateSubmissionDetails = async (appId: string, mobileApp: MobileAppsSubmission) => {
  try {
    const result = await api.resubmission(appId, mobileApp);
    return result.body;
  } catch (e) {
    throw mapServerError(e);
  }
};

export const mobileAppsService = {
  getMobileAppStatus,
  getSalesChannelConfig,
  getStatistics,
  getSubmissionDetails,
  updateMobileAppSubmissionStatus,
  updateSalesChannelConfig,
  updateSubmissionDetails,
  uploadLogo,
  getSubmissionDetailsQueryKey,
  saveSubmissionDetails,
};
